<template>
    <section class="blog__area pt-115 pb-120">
        <div class="container">
            <div class="row">
                <div class="col-xxl-12">
                    <div class="section__title-wrapper mb-60 text-center">
                        <h2 class="section__title">Blog <span class="yellow-bg yellow-bg-big">Yazıları<img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
                        <p>Psikoloji alanında güncel yazılar ve makaleler</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="post in posts" :key="post.id" class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
                    <router-link :to="'/blog-details/' + createSlug(post.title)" class="blog__item white-bg mb-30">
                        <div class="blog__thumb">
                            <img :src="post.image" :alt="post.title">
                        </div>
                        <div class="blog__content">
                            <h3 class="blog__title">{{ post.title }}</h3>
                            <p class="blog__excerpt">{{ post.content }}</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { jsonService } from '@/services/jsonService'

export default {
    name: 'BlogSection',
    setup() {
        const posts = ref([])

        const createSlug = (text) => {
            return text
                .toString()
                .toLowerCase()
                .replace(/\s+/g, '-')           // Boşlukları tire ile değiştir
                .replace(/[ğ]/g, 'g')           // Türkçe karakterleri değiştir
                .replace(/[ü]/g, 'u')
                .replace(/[ş]/g, 's')
                .replace(/[ı]/g, 'i')
                .replace(/[ö]/g, 'o')
                .replace(/[ç]/g, 'c')
                .replace(/[^a-z0-9-]/g, '')     // Alfanumerik ve tire dışındaki karakterleri kaldır
                .replace(/-+/g, '-')            // Ardışık tireleri tek tireye dönüştür
                .replace(/^-+/, '')             // Baştaki tireleri kaldır
                .replace(/-+$/, '')             // Sondaki tireleri kaldır
        }

        const loadPosts = async () => {
            const allPosts = await jsonService.getBlogPosts()
            // Son eklenen en üstte olacak şekilde sırala
            posts.value = allPosts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        }

        onMounted(() => {
            loadPosts()
        })

        return {
            posts,
            createSlug
        }
    }
}
</script>

<style scoped>
.blog__item {
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s ease;
    text-decoration: none;
    display: block;
}

.blog__item:hover {
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.blog__thumb {
    position: relative;
    overflow: hidden;
}

.blog__thumb img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    transition: all 0.3s ease;
}

.blog__item:hover .blog__thumb img {
    transform: scale(1.1);
}

.blog__content {
    padding: 20px;
    background: #fff;
}

.blog__title {
    font-size: 18px;
    font-weight: 600;
    color: #0e1133;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
}

.blog__excerpt {
    color: #666;
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    margin: 0;
}
</style> 